import { nextTick } from 'vue'

/**
 * `offsetParent` is null for `position: fixed` elements — which every dialog is — so
 * it cannot be used here. A rendered box always has at least one client rect.
 */
const isVisible = (el: Element) => el.getClientRects().length > 0

/**
 * Bring the first invalid field into view — `await` it on the failed branch of a submit.
 * The form hooks in this library already do, so a form written over one needs nothing.
 *
 * Without it a tall form answers a click by painting a message somewhere off screen, which
 * reads as a dead button.
 *
 * It scopes itself to the topmost dialog when there is one (Element Plus stacks overlays in
 * DOM order), and to the document when there is not, so a form inside a modal never scrolls
 * the page behind it. The field is not focused: focusing a select pops its dropdown open,
 * which is more disruptive than the scroll is helpful.
 */
export async function scrollToFirstError() {
  // Errors are painted on the next tick — the DOM has no `is-error` yet.
  await nextTick()

  const overlays = Array.from(document.querySelectorAll('.el-overlay')).filter(
    isVisible
  )
  const scope: ParentNode = overlays[overlays.length - 1] ?? document

  const field = Array.from(
    scope.querySelectorAll('.el-form-item.is-error')
  ).find(isVisible)

  field?.scrollIntoView({ behavior: 'smooth', block: 'center' })
}
